<template>
  <div>
    <router-view :key="$route.path"></router-view>
    <!-- Footer -->
    <div class="chat-container">
      <chat-form />
    </div>
    <footer-comp />

  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import firebase from "firebase/app";
import "firebase/messaging";
export default {
  name: "App",
  components: {
    FooterComp: () => import("./pages/views/web/components/footer.vue"),
    //ChatForm: () => import("./pages/views/web/components/chatForm")
  },
  data() {
    return {
      loader: false,
      messaging: ""
    };
  },
  computed: {
    ...mapState(["user", "loggedIn", "lang"])
  },
  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN",
      setLang: "SET_LANG",
      setUser: "SET_USER",
      setToken: "SET_TOKEN",
      //setRoles: "SET_ROLES"
    }),
    async setFCMToken(token) {
      const ses = {
        sesion: {
          idSesion: 0,
          token: token,
          usuario: this.$store.state.user.idUsuario,
          cliente: 0,
          fecha: new Date()
        }
      };

      await this.$http
        .post(route("NotificacionWeb/postNotificacionWebSesion"), ses)
        .then(
          async response => {
            if (response.body.code === 200) {
              // this.notifyMessage("success", this.$t("app.promps.save_success"));
            } else {
              // this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            // this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async getNotCount() {
      const params = {
        Id: this.$store.state.user.idUsuario,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0
      };

      await this.$http
        .post(route("NotificacionWeb/getNotificacionesWebConteo"), params)
        .then(
          response => {
            if (response.body.code === 200) {
              this.$store.state.not_count = response.body.id;
              console.log(
                "Notificaciones sin leer: " + this.$store.state.not_count
              );
            } else {
              console.log(response.body);
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.error(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        );
    }
  },
  watch: {
    "$store.state.loggedIn": function() {
      console.log(this.$store.state.loggedIn);
      if (this.$store.state.loggedIn) {
        if(this.$store.state.loginDate != new Date().toJSON().slice(0,10).replace(/-/g,'/')){
          this.messaging.deleteToken();
        }
        this.messaging
          .requestPermission()
          .then(() => firebase.messaging().getToken())
          .then(token => {
            console.log(token); // Receiver Token to use in the notification
            this.setFCMToken(token);
          })
          .catch(function(err) {
            console.log("Unable to get permission to notify.", err);
          });
        this.getNotCount();
      }
    }
  },
  created() {
    Vue.http.interceptors.push(function(request, next) {
      request.headers.set("Access-Control-Allow-Origin", "*");
      request.headers.set(
        "Access-Control-Allow-Headers",
        "Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin"
      );
      if (this.$store.state.loggedIn) {
        request.headers.set(
          "Authorization",
          "Bearer " + this.$store.state.token
        );
      }
      this.$root.$i18n.locale = this.$store.state.lang;

      next(function(response) {
        if (response.status == 401) {
          this.$router.push({
            name: "Logout"
          });
        }
      });
    });

    // FCM receive messages
    var config = {
      apiKey: "AIzaSyDGr29vfmSQBEVEFWqSfGNonIuxVD7QcjY",
      authDomain: "redi-3bb7c.firebaseapp.com",
      projectId: "redi-3bb7c",
      storageBucket: "redi-3bb7c.appspot.com",
      messagingSenderId: "268348036881",
      appId: "1:268348036881:web:9aa0a9a75251a0fe9bdeb0"
    };
    firebase.initializeApp(config);

    this.messaging = firebase.messaging();
    if (this.$store.state.loggedIn) {
      this.messaging
        .requestPermission()
        .then(() => firebase.messaging().getToken())
        .then(token => {
          console.log(token); // Receiver Token to use in the notification
          this.setFCMToken(token);
        })
        .catch(function(err) {
          console.log("Unable to get permission to notify.", err);
        });
    }
    this.messaging.onMessage(function(payload) {
      console.log("Message received. ", payload);
      this.notifyMessage("info", payload);
    });

    if (this.$store.state.loggedIn) {
      // Load notification count
      this.getNotCount();
    }
  },
  mounted() {
    EventBus.$on("delete-messaging-token", () => {
      this.messaging.deleteToken();
    });
  }
};
</script>

<style scoped>

.chat-container{
  text-align: right;
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 9999;
}

</style>
